const $ = jQuery;
$.fn.softScroller = function(){
	var getMargin =  function (element) {
		var style;
		if (window.getComputedStyle) { 
			style = window.getComputedStyle(element, null); 
		}
		else 
			{ style = element.currentStyle; }

		return {
			top: parseFloat(style.marginTop.replace('px','')),
			bottom: parseFloat(style.marginBottom.replace('px', ''))
		}
	}
	var updatePosition = function($item, containerTop, containerBottom){
		var contentTop = $item.parents('.entry-content').offset().top;
		var itemHeight = $item.height();
		var wh = $(window).height();
		var pmin = containerTop - contentTop;
		var pmax = containerBottom  - contentTop - itemHeight;
		var ymin = containerTop;
		var ymax = containerBottom - wh;
		var scrollPos = $(window).scrollTop();
		if (scrollPos < pmin){
			$item.css('position', 'absolute').css('top', pmin );
			return;
		}
		if ( scrollPos >= ymin && scrollPos  <= ymax ){
			let a = (pmax-pmin)/(ymax-ymin);
			let b = pmin - (a * ymin);
			var offset = a * (scrollPos) + b; 
			$item.css('position', 'absolute').css('top', offset);  
			
			return;
		}
		if (scrollPos > ymax){
			$item.css('position', 'absolute').css('top', pmax);
			return;
		}
	}
	let $this = this;

	$(window).on('scroll', function(){
		$this.each(function(){
			var anchorTop = $(this).attr('data-anchor-top');
			var anchorBottom = $(this).attr('data-anchor-bottom');
			var at = $(anchorTop).length?$(anchorTop).offset().top:$(this).parents('.entry-content').offset().top;
			var bt = $(anchorBottom).length?$(anchorBottom).offset().top+$(anchorBottom).height():$(this).parents('.entry-content').offset().top+$(this).parents('.entry-content').height();
			updatePosition($(this), at, bt)
		})
	});
	

}


$(document).ready(function(){
	$('.soft-scroll').softScroller();
});